import { useCallback, useReducer } from "react";
import { isBlank, notBlank } from "../util/ext";
import { lensProp, mergeRight, set } from "ramda";

const actionTypes = {
  update_page: "update_page",
  update_filter: "update_filter",
  update_module: "update_module",
  update_organization: "update_organization",
  update_types: "update_types",
  update_orderBy: "update_orderBy",
  update_activeOnly: "update_activeOnly",
  update_perpetualOnly: "update_perpetualOnly",
  update_includeIndirect: "update_includeIndirect",
  update_search: "update_search",
};

const useSearchFilter = (initialState = {}) => {
  const searchFindReducer = (state, action) => {
    switch (action.type) {
      case actionTypes.update_page:
        return { ...state, page: action.page };
      case actionTypes.update_filter:
        return {
          ...state,
          appliedFilter: action.filter,
          page: 0,
        };
      case actionTypes.update_activeOnly:
        return {
          ...state,
          activeOnly: action.activeOnly,
          page: 0,
        };
      case actionTypes.update_perpetualOnly:
        return {
          ...state,
          perpetualOnly: action.perpetualOnly,
          page: 0,
        };
      case actionTypes.update_includeIndirect:
        return {
          ...state,
          includeIndirect: action.includeIndirect,
          page: 0,
        };
      case actionTypes.update_module:
        return {
          ...state,
          appliedModule: action.module,
          page: 0,
        };
      case actionTypes.update_organization:
        return {
          ...state,
          appliedOrganization: action.organization,
          includeIndirect:
            (state.includeIndirect || isBlank(state.appliedOrganization)) &&
            notBlank(action.organization),
          page: 0,
        };
      case actionTypes.update_types:
        return {
          ...state,
          appliedTypes: action.types,
          page: 0,
        };
      case actionTypes.update_orderBy:
        return {
          ...state,
          orderBy: action.field,
          orderDirection: action.direction,
          page: initialState.page,
        };
      case actionTypes.update_search:
        return mergeRight(set(lensProp(action.field), action.value, state), {
          page: 0,
        });
      default:
        return state;
    }
  };

  const [state, dispatch] = useReducer(searchFindReducer, initialState);

  const handleUpdateSort = useCallback(({ property, order }) => {
    dispatch({
      type: actionTypes.update_orderBy,
      field: property,
      direction: order,
    });
  }, []);

  const handleUpdateFilter = useCallback(filter => {
    dispatch({ type: actionTypes.update_filter, filter: filter });
  }, []);

  const handleUpdateActiveOnly = useCallback(activeOnly => {
    dispatch({ type: actionTypes.update_activeOnly, activeOnly: activeOnly });
  }, []);

  const handleUpdatePerpetualOnly = useCallback(perpetualOnly => {
    dispatch({
      type: actionTypes.update_perpetualOnly,
      perpetualOnly: perpetualOnly,
    });
  }, []);

  const handleUpdateIncludeIndirect = useCallback(includeIndirect => {
    dispatch({
      type: actionTypes.update_includeIndirect,
      includeIndirect: includeIndirect,
    });
  }, []);

  const handleUpdatePage = useCallback(page => {
    dispatch({ type: actionTypes.update_page, page: page });
  }, []);

  const handleUpdateOrganization = useCallback(organization => {
    dispatch({
      type: actionTypes.update_organization,
      organization: organization,
    });
  }, []);

  const handleUpdateModule = useCallback(module => {
    dispatch({
      type: actionTypes.update_module,
      module: module,
    });
  }, []);

  const handleUpdateTypes = useCallback(types => {
    dispatch({
      type: actionTypes.update_types,
      types: types,
    });
  }, []);

  const handleUpdateSearch = useCallback((field, value) => {
    console.log("#####################################");
    console.log(value);
    console.log("#####################################");
    dispatch({
      type: actionTypes.update_search,
      field,
      value,
    });
  }, []);

  return {
    state,
    handleUpdateSort,
    handleUpdateFilter,
    handleUpdatePage,
    handleUpdateModule,
    handleUpdateOrganization,
    handleUpdateTypes,
    handleUpdateActiveOnly,
    handleUpdatePerpetualOnly,
    handleUpdateIncludeIndirect,
    handleUpdateSearch,
  };
};

export { actionTypes, useSearchFilter };
